import Vue from 'vue';
import Vuex from 'vuex';
import mainModule from './main';
import invoiceModule from './invoice';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main: mainModule,
    invoice: invoiceModule,
  },
});
